import axios from "axios";
import { endpoints } from "../_config";

/**
 * Career service (Amity / Amizone LineUpX SSO).
 *
 * Calls our own backend, which proxies the Amizone LineUpXLogin API server-side
 * (a direct browser call is blocked by Amizone's CORS preflight). The backend
 * derives the Amity email from the authenticated user, so we only send the
 * auth token here.
 */
class CareerService {
  /**
   * Get a one-time career portal login URL for the logged-in user.
   * @param {object} user - the logged-in user (needs .token)
   * @returns {Promise<{ redirectUrl: string }>}
   */
  static async lineUpXLogin(user) {
    return axios
      .post(
        endpoints.career.lineUpXLogin,
        {},
        {
          headers: {
            Authorization: "Bearer " + (user ? user.token : null),
          },
        }
      )
      .then((response) => response.data?.data);
  }
}

export { CareerService };
